/**
 * Strips a Sylius country prefix from a province code for display (e.g. US-TX → TX).
 */
export function unPrefixStateCode(stateCode: string): string {
  if (!stateCode) {
    return '';
  }

  const trimmed = stateCode.trim();
  if (/^[A-Za-z]{2}-/.test(trimmed)) {
    return trimmed.slice(3);
  }

  return trimmed;
}
